
/**
 * @param {string} nodeName
 * @param {HTMLElement} node
 */
export function findHrBlock(nodeName, node) {
	if (nodeName === 'hr') {
		return {
			type: 'atomic',
			text: '----'
		}
	}
}



// WEBPACK FOOTER //
// ./lib/convert/html/finder/findHrBlock.js